import { ComponentProps, FC } from 'react';
import { useTranslation } from 'next-i18next';
import { BannerBox } from '../../box/BannerBox';
import { VariationIcon } from '../VariationIcon/VariationIcon';

export const ConversionOverPriceBanner: FC<ComponentProps<typeof BannerBox>> = ({ ...props }) => {
  const { t } = useTranslation('price-drop');

  return (
    <BannerBox
      variant="warning"
      title={t('PRICE_DROP.PRICE_ZONE.CONVERSION.OVER_PRICE.TITLE')}
      titleIcon={<VariationIcon name={'warning'} />}
      description={t('PRICE_DROP.PRICE_ZONE.CONVERSION.OVER_PRICE.INFO')}
      showLearnMoreButton={true}
      {...props}
    />
  );
};
